module.exports = "https://dev.stanwinstonschool.com/2-history-desktop.680f5d7dc57a0bae264ee4499db0136a.jpg";